import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import { HttpResponse } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from './../../../constants/endpoints';
import { Value } from '@philips-internal/oswald-ui-core';

export interface OralSupplementsCreatePrescriptionScheduleChangeRequest {
  amountAdministered: number;
  encounterId: number;
  eventDate: string;
  intervalCode: string;
  itemCode: string;
  itemDescription: string;
  itemQuantity: number;
  itemSequence: number;
  justificationDescription: string;
  observationDescription: string;
  prescriptionNumber: number;
  prescriptionsNumber: string;
  scheduleSequence: number;
  unitMeasureCode: string;
}

export interface OralSupplementsCreatePrescriptionScheduleChangeResponse {
  evolutionCodeResponse: number,
  messageDescriptionResponse: string
}

export default class OralSupplementsService {

  public static oralSupplementsCreatePrescriptionScheduleChange(
    scheduleSequence: number, request: OralSupplementsCreatePrescriptionScheduleChangeRequest): Promise<HttpResponse<OralSupplementsCreatePrescriptionScheduleChangeResponse>> {
    const body = Object.assign({}, request) as unknown as Record<string, Value>;

    return HttpService.put(
      Endpoint.EMAR_ORAL_SUPPLEMENTS_CREATE_PRESCRIPTION_SCHEDULE_CHANGE, { scheduleSequence },
      { body }
    )
  }
}